var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/key"
  }, /*#__PURE__*/React.createElement("g", {
    id: "key"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4917 12.4417C14.775 14.15 12.3167 14.675 10.1584 14L6.23337 17.9167C5.95004 18.2083 5.39171 18.3833 4.99171 18.325L3.17504 18.075C2.57504 17.9917 2.01671 17.425 1.92504 16.825L1.67504 15.0083C1.61671 14.6083 1.80837 14.05 2.08337 13.7667L6.00004 9.85C5.33337 7.68333 5.85004 5.225 7.56671 3.51666C10.025 1.05833 14.0167 1.05833 16.4834 3.51666C18.95 5.975 18.95 9.98333 16.4917 12.4417Z",
    stroke: "#181C32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.7417 14.575L7.65837 16.4917",
    stroke: "#181C32",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.0835 9.16666C12.7739 9.16666 13.3335 8.60701 13.3335 7.91666C13.3335 7.2263 12.7739 6.66666 12.0835 6.66666C11.3931 6.66666 10.8335 7.2263 10.8335 7.91666C10.8335 8.60701 11.3931 9.16666 12.0835 9.16666Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.2e670091caa26553bc4fe302d7aa3d6d.svg";
export { ForwardRef as ReactComponent };